import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const message = error?.message || String(error);
    const stack = error?.stack || '';

    return (
      <div style={{ minHeight: '100vh', padding: '40px 24px', fontFamily: 'system-ui, sans-serif', backgroundColor: '#FFF5F5' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '22px', marginBottom: '8px', color: '#991B1B' }}>Something went wrong on this page</h1>
          <p style={{ fontSize: '14px', color: '#7F1D1D', marginBottom: '24px' }}>
            The page hit an unexpected error while rendering. You can retry, or send a screenshot of the details below for diagnosis.
          </p>
          <button
            onClick={() => this.setState({ error: null })}
            style={{ padding: '10px 18px', marginRight: '8px', background: '#DC2626', color: 'white', border: 'none', cursor: 'pointer', fontWeight: 600 }}
          >
            Try again
          </button>
          <button
            onClick={() => window.history.back()}
            style={{ padding: '10px 18px', background: 'white', color: '#111', border: '1px solid #ccc', cursor: 'pointer', fontWeight: 600 }}
          >
            Go back
          </button>
          <pre style={{ marginTop: '24px', padding: '16px', background: '#fee', border: '1px solid #fca5a5', overflow: 'auto', fontSize: '12px', whiteSpace: 'pre-wrap' }}>
            <strong>Error:</strong> {message}
            {stack && (<><br /><br /><strong>Stack:</strong>{'\n'}{stack}</>)}
          </pre>
        </div>
      </div>
    );
  }
}
